export const offer = {
  header_title: "Offres",
  update_form_name: " Mettre à jour l'offre",
  create_form: {
    title: "Créer une offre",
    name: "Nom",
    name_placeholder: "Nom de l'offre",
    price: "Prix",
    price_placeholder: "Prix de l'offre",
    type: "Type de service",
    type_placeholder: "Type de service",
    description: "Description",
    description_placeholder: "Description de l'offre",
    class: "Classe comptable",
    class_placeholder: "Classe comptable",
    category: "Catégorie",
    category_placeholder: "Catégorie de l'offre",
    submit: "Créer",
    creating: "Création...",
    category_custom: "Autre (saisir manuellement)",
    updating: "Mise à jour...",
    update: "Modifier",
    types: {
      product: "Produit",
      service: "Service",
    },
    categories: {
      informatique: "Informatique",
      nourriture: "Nourriture",
      electronique: "Électronique",
      mobilier: "Mobilier",
      transport: "Transport",
      services: "Services",
      marketing: "Marketing",
      sante: "Santé",
      construction: "Construction",
      education: "Éducation",
    },
    create_success: "Offre crée avec succès!",
    update_success: "Offre mise à jour avec succès!",
    delete_success: "Offre supprimée avec succès!",
    create_error: "Erreur lors de la création de l'offre",
    update_error: "Erreur lors de la mise à jour de l'offre",
    delete_error: "Erreur lors de la suppression de l'offre",
    class_custom: "Autre (saisir manuellement)",
  },
  actions: {
    edit: "Modifier",
    delete: "Supprimer",
  },
  delete_dialog: {
    title: "Supprimer l'offre",
    description: "Voulez-vous vraiment supprimer cette offre ?",
    submit: "Supprimer",
    cancel: "Annuler",
  },
  back_to_list: "Retour à la liste",
};
